import {postMethod} from '@/api'
export const post = async ({bookingKey, paymentMethodId}) =>
    await postMethod('/api/modifyService', null, {params: {bookingKey, paymentMethodId}})
